'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialSkype = function IoSocialSkype(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.1 23.2c0.6 1.1 0.9 2.3 0.9 3.6 0 4.5-3.7 8.2-8.3 8.2-1.4 0-2.7-0.3-3.9-0.9-0.8 0.1-1.7 0.2-2.6 0.2-7.9 0-14.3-6.3-14.3-14.1 0-1 0.1-1.9 0.3-2.9-0.7-1.2-1.2-2.6-1.2-4.1 0-4.5 3.7-8.2 8.3-8.2 1.6 0 3.2 0.5 4.4 1.2 0.8-0.1 1.6-0.1 2.5-0.1 7.8 0 14.3 6.2 14.3 14.1 0 1-0.1 2.1-0.4 3z m-6.6 3.7c0.7-1 0.9-2 0.9-3.1 0-1-0.1-1.8-0.5-2.5s-0.9-1.3-1.6-1.8-1.5-0.7-2.5-1.1-2-0.5-3.2-0.7c-0.9-0.3-1.5-0.4-1.9-0.5s-0.8-0.3-1.2-0.5-0.5-0.4-0.8-0.6c-0.1-0.2-0.3-0.5-0.3-0.8 0-0.5 0.2-1 0.9-1.4s1.4-0.5 2.5-0.5c1.1 0 1.9 0.1 2.4 0.5s0.8 0.9 1.2 1.6c0.4 0.5 0.7 0.8 0.9 1.1 0.3 0.2 0.7 0.4 1.2 0.4 0.7 0 1.1-0.3 1.5-0.7s0.6-0.8 0.6-1.3c0-0.5-0.2-1.1-0.5-1.6s-0.8-1.1-1.4-1.6-1.4-0.9-2.3-1.2-2.2-0.4-3.4-0.4c-1.6 0-3 0.2-4.1 0.7-1.3 0.4-2.2 1.1-2.9 1.9-0.6 0.9-0.9 1.7-0.9 2.8s0.2 2.1 0.9 2.8 1.5 1.4 2.5 1.8c1 0.4 2.2 0.8 3.7 1.1 1.1 0.3 2 0.4 2.7 0.6 0.6 0.2 1.1 0.5 1.5 0.9 0.3 0.3 0.5 0.8 0.5 1.3 0 0.7-0.3 1.4-1 1.8s-1.7 0.7-2.9 0.7c-0.9 0-1.6-0.1-2.1-0.4s-0.9-0.4-1.2-0.8-0.6-0.9-0.8-1.5-0.5-0.9-0.8-1.2-0.8-0.4-1.3-0.4c-0.6 0-1.1 0.1-1.5 0.5s-0.6 0.8-0.6 1.3c0 0.9 0.3 1.8 1 2.6s1.4 1.5 2.3 2c1.3 0.8 3 1.1 5.1 1.1 1.7 0 3.3-0.2 4.5-0.7s2.3-1.3 2.9-2.2z' })
        )
    );
};

exports.default = IoSocialSkype;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-skype.js
// module id = 2952
// module chunks = 168707334958949